import { render } from "./confirmModal.vue?vue&type=template&id=348d883a&ts=true"
import script from "./confirmModal.vue?vue&type=script&lang=ts"
export * from "./confirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__